import { isBlankString } from './stringUtils';
import { triggerCountrySelect } from './eventUtils';
import Cookies from '../services/cookies';
import { COOKIE_NAME_CURRENCY } from '../constants';

export function findCountryInCountriesList(countriesList, countryCode) {
    function matchingCountry(country) {
        return _.toUpper(countryCode) === _.toUpper(_.get(country, 'isoCode', ''));
    }

    const foundCountry = _.find(countriesList, matchingCountry);

    return foundCountry;
}

export function findCurrencyFormattingInfo(featureConfigs, currency) {
    const currencyFormattingInfoList = _.map(_.get(featureConfigs, 'currencies.currencies', []), 'fields');

    const foundCurrencyInfo = _.find(currencyFormattingInfoList, (currencyFormattingInfo) => {
        return currency === currencyFormattingInfo.currencyCode;
    });

    return foundCurrencyInfo;
}

export function getCountryAndCurrencyData(state, countryCode, currencyParam) {
    if (!_.isString(countryCode) || _.size(_.trim(countryCode)) === 0) {
        return null;
    }

    let currency = currencyParam;

    if (isBlankString(currency)) {
        currency = Cookies.getCookieByName(COOKIE_NAME_CURRENCY);
    }

    const countryList = _.get(state, 'core.constants.utilityNavOptions.countriesList', []);
    const featureConfigs = _.get(state, 'core.featureConfigs', {});
    const foundCountry = findCountryInCountriesList(countryList, countryCode);
    const currencyFormattingInfo = findCurrencyFormattingInfo(featureConfigs, currency);

    const result = {};

    if (foundCountry) {
        const countryFields = _.pick(foundCountry, ['isoCode', 'displayName']);

        if (_.isString(countryFields.isoCode)) {
            result.country = _.toUpper(countryFields.isoCode);
        }

        if (_.isUndefined(countryFields.displayName)) {
            result.countryDisplayName = _.toUpper(countryFields.isoCode);
        } else {
            result.countryDisplayName = countryFields.displayName;
        }
    }

    if (currencyFormattingInfo) {
        result.currency = currency;
        result.currencyFormattingInfo = currencyFormattingInfo;
    }

    return result;
}

/**
 * Set correct default country from the Redux store at the given selector IF
 * the selector currently has no value set
 * @param {Object} store Redux store
 * @param {jQuery} countrySelect jQuery result for the country select element
 * @return {undefined}
 */
export function setDefaultCountry(store, countrySelect) {
    const defaultCountry = getDefaultCountry(store);
    if (countrySelect.length > 0 && !countrySelect.val()) {
        countrySelect.val(defaultCountry);
        countrySelect.children(`option[val="${defaultCountry}"]`)
            .prop('selected', true);

        triggerCountrySelect();
    }
}

/**
 * Get correct default country from the Redux store, either using
 * UK/China site-ID or core.userLocation.country_code
 * @param {Object} store Redux store
 * @return {String} Country code for correct country or empty string
 */
export function getDefaultCountry(store) {
    const state = store.getState();
    const isUK = _.endsWith(state.core.siteId, '-uk');
    const isChina = _.endsWith(state.core.siteId, '-cn');
    if (isUK) {
        return "GB";
    }
    if (isChina) {
        return "CN";
    }
    return _.get(state, "core.userLocation.country_code", "");
}
